"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var visor_1 = require("./components/visor");

var visorSingleton;
var DEFAULT_TAB = 'Visor';
var VISOR_CONTAINER_ID = 'tfjs-visor-container';

function visor() {
  if (typeof document === 'undefined') {
    throw new Error('No document defined. This library needs a browser/dom to work');
  }

  if (document.getElementById(VISOR_CONTAINER_ID) && visorSingleton != null) {
    return visorSingleton;
  }

  var visorEl = document.getElementById(VISOR_CONTAINER_ID);

  if (visorEl == null) {
    visorEl = document.createElement('div');
    visorEl.id = VISOR_CONTAINER_ID;
    document.body.appendChild(visorEl);
  }

  var renderRoot;

  function renderVisor(domNode, surfaceList) {
    var visorInstance;
    renderRoot = visor_1.VisorComponent.render(domNode, renderRoot, {
      ref: function ref(r) {
        return visorInstance = r;
      },
      surfaceList: Array.from(surfaceList.values())
    });
    return visorInstance;
  }

  var surfaceList = new Map();
  var visorComponentInstance = renderVisor(visorEl, surfaceList);
  visorSingleton = new Visor(visorComponentInstance, visorEl, surfaceList, renderVisor);
  return visorSingleton;
}

exports.visor = visor;

var Visor =
/*#__PURE__*/
function () {
  function Visor(visorComponent, visorEl, surfaceList, renderVisor) {
    _classCallCheck(this, Visor);

    this.visorComponent = visorComponent;
    this.el = visorEl;
    this.surfaceList = surfaceList;
    this.renderVisor = renderVisor;
  }

  _createClass(Visor, [{
    key: "surface",
    value: function surface(options) {
      var name = options.name;
      var tab = options.tab == null ? DEFAULT_TAB : options.tab;

      if (name == null || !(typeof name === 'string' || name instanceof String)) {
        throw new Error('You must pass a config object with a \'name\' property to create or retrieve a surface');
      }

      var finalOptions = Object.assign({}, options, {
        tab: tab
      });
      var key = "".concat(name, "-").concat(tab);

      if (!this.surfaceList.has(key)) {
        this.surfaceList.set(key, finalOptions);
      }

      this.renderVisor(this.el, this.surfaceList);
      return this.visorComponent.getSurface(name, tab);
    }
  }, {
    key: "isFullscreen",
    value: function isFullscreen() {
      return this.visorComponent.isFullscreen();
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.visorComponent.isOpen();
    }
  }, {
    key: "close",
    value: function close() {
      return this.visorComponent.close();
    }
  }, {
    key: "open",
    value: function open() {
      return this.visorComponent.open();
    }
  }, {
    key: "toggle",
    value: function toggle() {
      return this.visorComponent.toggle();
    }
  }, {
    key: "toggleFullScreen",
    value: function toggleFullScreen() {
      return this.visorComponent.toggleFullScreen();
    }
  }, {
    key: "bindKeys",
    value: function bindKeys() {
      return this.visorComponent.bindKeys();
    }
  }, {
    key: "unbindKeys",
    value: function unbindKeys() {
      return this.visorComponent.unbindKeys();
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(tabName) {
      var tabs = this.visorComponent.state.tabs;

      if (!tabs.has(tabName)) {
        throw new Error("Tab '".concat(tabName, "' does not exist"));
      }

      this.visorComponent.setState({
        activeTab: tabName
      });
    }
  }]);

  return Visor;
}();

exports.Visor = Visor;